import { LAYOUTS, } from "@voltmoney/types";
import { ApplicationPendingBlockedStatus, ApplicationPendingContext, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { contactUs, navAction } from "./actions";
import { logout } from "../profile/my_profile/actions";
import { CreditApplicationStepId } from "../../configs/constants";
import sharedPropsService from "../../SharedPropsService";
export const template = (height, applicationState, title, subtitle, context, btnTitle, disableCta) => ({
    layout: {
        id: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'applicationPendingBlockedPage', type: WIDGET.APPLICATION_PENDING_BLOCKED_PAGE }
        ],
    },
    datastore: {
        applicationPendingBlockedPage: {
            height: height,
            state: applicationState,
            title: `${title}`,
            subtitle: `${subtitle}`,
            contactUsAction: {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                type: ACTION.CONTACT_US,
                payload: {}
            },
            logoutAction: {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                type: ACTION.LOGOUT,
                payload: {}
            },
            ...btnTitle && {
                btnTitle: btnTitle
            },
            action: {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                type: ACTION.NAV_ACTION,
                payload: {
                    context: context
                }
            },
            context: context,
            disableCta: disableCta
        }
    },
});
export const applicationPendingBlockingMf = {
    onLoad: async ({ getHeight, instrumentTrack }, { applicationState }) => {
        const user = await sharedPropsService.getUser();
        const currentStepId = user?.linkedApplications[0]?.currentStepId;
        let title = '';
        let subtitle = '';
        let context = ApplicationPendingContext.DEFAULT;
        let btnTitle = undefined;
        let disableCta = false;
        const currentApplicationState = user?.linkedApplications[0]?.applicationState;
        if (applicationState === undefined) {
            applicationState = currentApplicationState;
        }
        if (applicationState === ApplicationPendingBlockedStatus.DENIED) {
            instrumentTrack('LOAN_APPLICATION_REJECTED_PAGE_VIEWED', { current_step: currentStepId });
            switch (currentStepId) {
                case CreditApplicationStepId.KYC_DOCUMENTS:
                    title = 'KYC verification request rejected';
                    subtitle = 'We couldn\'t verify your request using the document you provided.';
                    context = ApplicationPendingContext.KYC_MISMATCH;
                    btnTitle = 'Start KYC again';
                    break;
                case CreditApplicationStepId.BANK_ACCOUNT_VERIFICATION:
                    title = 'Bank verification request rejected';
                    subtitle = 'We couldn\'t verify your request using the document you provided.';
                    context = ApplicationPendingContext.BANK_MISMATCH;
                    btnTitle = 'Add another bank account';
                    break;
                case CreditApplicationStepId.KYC_PHOTO_VERIFICATION:
                    title = 'Photo verification request rejected';
                    subtitle = 'We couldn\'t verify your request using the document you provided.';
                    context = ApplicationPendingContext.PHOTO_MISMATCH;
                    btnTitle = 'Retry KYC';
                    disableCta = true;
                    break;
            }
        }
        if (context === ApplicationPendingContext.DEFAULT) {
            title =
                applicationState === ApplicationPendingBlockedStatus.BLOCKED
                    ? 'Your application in under review'
                    : 'Your application was rejected by our lending partner';
            if (currentStepId === CreditApplicationStepId.KYC_DOCUMENTS) {
                title = 'Your documents are under review';
                subtitle = 'We are actively assessing your documents. You should receive a response within 2 business hours.';
            }
            else {
                if (applicationState === ApplicationPendingBlockedStatus.BLOCKED) {
                    instrumentTrack('LOAN_APPLICATION_UNDER_REVIEW_PAGE_VIEWED', { current_step: currentStepId });
                    subtitle = 'Your application is currently on hold. However, we are actively assessing it. You should receive a response within 2 business hours.';
                }
                else {
                    subtitle = 'Your credit profile currently does not meet the policy guidelines of our lending partner. Please try again after 30 days.';
                }
            }
        }
        return Promise.resolve(template(getHeight(), applicationState, title, subtitle, context, btnTitle, disableCta));
    },
    actions: {
        [ACTION.CONTACT_US]: contactUs,
        [ACTION.LOGOUT]: logout,
        [ACTION.NAV_ACTION]: navAction,
    },
};
